
function createModifiers({ menu, modgroup, modPrefixId }) {
  let {autoGenFromTag, discountMultiplier, fixedPrice, priceIf} = modgroup
  // console.log(autoGenFromTag)
  discountMultiplier = Number(discountMultiplier)
  fixedPrice = Number(fixedPrice)

  let modifiers = []
  menu.subMenus.forEach((subMenu) => {
    
    if (!subMenu.tag) {return}
    if (subMenu.tag.indexOf(autoGenFromTag) !== -1) {
      

      subMenu.products.forEach((product) => {
        let { name, price, id, photo, description } = product
        // console.log({autoGenFromTag, discountMultiplier, fixedPrice})
        photo = photo || null
        name = name && name.en
        description = description && description.en    
        let originalPrice = false
        if (discountMultiplier) {
          originalPrice = price
          price = Math.ceil(Number(price) * (1-discountMultiplier) * 100) / 100
        }
        if (Number.isFinite(fixedPrice)) {
          originalPrice = price
          price = fixedPrice
          console.log('fixed price:', price)
        }
        if (priceIf) {
          let modPriceIf = priceIf
          const productPrice = Number(price)
          if (Number.isFinite(productPrice) && productPrice !== 0) {
            modPriceIf = priceIf.map(entry => ({
              ...entry,
              price: Math.round(((Number(entry.price) || 0) + productPrice) * 100) / 100
            }))
          }
          modifiers.push({
            id: (modPrefixId + id), name: name, priceIf: modPriceIf, photo, description
          })
          return
        }
        
        modifiers.push({
          id: (modPrefixId + id), name: name, price: Number(price), originalPrice, photo, description
        })
      })
    }
  })

  return modifiers
}

function isDateGated(tagStr) {
  const match = tagStr.match(/date-gate-(\d{4}-\d{2}-\d{2})/)
  if (!match) return false
  const now = new Date()
  const today = now.getFullYear() + '-' +
    String(now.getMonth() + 1).padStart(2, '0') + '-' +
    String(now.getDate()).padStart(2, '0')
  return match[1] !== today
}

// shown on the POS (jingpos), hidden from online ordering
function isPosOnly(tagStr) {
  return tagStr.indexOf('only-on-pos') !== -1
}

export default function unzipMenu (menu) {
  try {
    menu.subMenus.forEach((subMenu) => {
      subMenu.products.forEach((product) => {
        if (product.modgroups) {
          product.modgroups.forEach((modgroup, index) => {
            if (!modgroup) { return }
            const autoGenFromTag = modgroup.autoGenFromTag
            const daysOfWeek = modgroup.daysOfWeek
            if (daysOfWeek) {
              const now = new Date()
              const currentDayOfWeek = now.getDay()
              if (daysOfWeek.indexOf(currentDayOfWeek) === -1) {
                delete product.modgroups[index]
              }
            }
            if (autoGenFromTag) {
              // const newModgroup = Object.assign({}, modgroup, {
              //   modifiers: createModifiers({ menu, modgroup })
              // })
              const newMods = createModifiers({ menu, modgroup, modPrefixId: modgroup.id })
              product.modgroups[index].modifiers = newMods
              // console.log(newMods)
            }
          })
        }
      })
    })

    // filter out date-gated and POS-only categories and products
    menu.subMenus = menu.subMenus.filter(sub => !sub.tag || (!isDateGated(sub.tag) && !isPosOnly(sub.tag)))
    menu.subMenus.forEach(sub => {
      // product.tags is a comma-separated string in every live menu, not an
      // array — calling .some() on it threw a TypeError that this function's
      // own try/catch swallowed, silently skipping product-level date gating
      // (and everything below it). isDateGated regex-searches the whole
      // string, so the string can be passed through as-is.
      sub.products = sub.products.filter(p => {
        if (!p.tags) { return true }
        const tags = Array.isArray(p.tags) ? p.tags : [p.tags]
        return !tags.some(t => typeof t === 'string' && (isDateGated(t) || isPosOnly(t)))
      })
    })

  } catch (e) {
    return menu
  }
  // console.log('debug unzip')
  // console.log(menu)


  return menu
}
